import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { FreeDataArgs } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';

export class FreedataArgsVO {

    /** Le modèle pour l'accés au parentVO */
    protected _model: Model;

    
    constructor(model: Model, pSource?: FreeDataArgs) {
        this._model = model; 
        this._source = null;
        if (pSource) {
            this._source = pSource;
        } else {
            this._source = new FreeDataArgs();
            this._source.uid = WizMathUtils.createUUID(); // génération du UID si nouveau
        }
    }

    /** L'objet source provenant du back */
    protected _source: FreeDataArgs;

    public set source(src: FreeDataArgs) {
        this._source = src;
    }
    public get source(): FreeDataArgs {
        return this._source;
    }

    public set code(code: string) {
        this._source.code = code;
    }
    public get code(): string {
        return this._source.code;
    }

    /** type de champ */
    public set dataType(value: string) {
        this._source.dataType = value;
    }
    public get dataType(): string {
        return this._source.dataType;
    }

}
